import * as types from "../actions/types/analytics.types";

const initialState = {
  initialTransactionList: [],
  transactionList: [],
  filterStartDateValue: null,
  filterEndDateValue: null,
  filterTransactionsByDateState: "idle",
  dateFilterTransactions: false,
};

export const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FILTER_TRANSACTIONS_STARTED:
      return {
        ...state,
        filterTransactionsByDateState: "loading",
      };
    case types.FILTER_TRANSACTIONS_SUCCEEDED:
      return {
        ...state,
        filterTransactionsByDateState: "success",
        transactionList: action.payload.data,
        dateFilterTransactions: true,
      };
    case types.FILTER_TRANSACTIONS_FAILED:
      return {
        ...state,
        filterTransactionsByDateState: "failed",
      };
    case types.SET_TRANSACTION_LIST:
      return {
        ...state,
        initialTransactionList: action.payload,
        transactionList: action.payload,
      };
    default:
      return state;
  }
};
